<template>
  <div>
    <keep-alive>
      <transition>
        <router-view />
      </transition>
    </keep-alive>
  </div>
</template>
<script>
import { getToken } from '@/utils/storage';
import { mapActions } from 'vuex';
import Url from 'url-parse';
export default {
  data() {
    return {
      transitionName: ''
    };
  },
  created() {},
  mounted() {
    // 绑定微信账户信息, 注意此处不能使用router来获取code,是undfined
    const url = new Url(location.href, true);
    const { code } = url.query;
    if (code) {
      this.onBindWeixinInfo(code);
    }
    if (getToken()) {
      this.GetUserInfo();
    }
    const userAgent = window.navigator.userAgent;
    this.setIsWeixinGongzhonghao(userAgent.toLowerCase().indexOf('micromessenger') > -1);
  },
  methods: {
    ...mapActions(['GetUserInfo', 'setIsWeixinGongzhonghao', 'onBindWeixinInfo'])
  }
};
</script>
<style lang="scss" scoped></style>
